package com.tixforgigs.common.core.theme

import com.tixforgigs.common.core.enums.DeviceClass
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.theme.Styles.CustomClasses.Companion.FLEXBOX_GROWING_ITEM
import com.tixforgigs.common.core.theme.Styles.CustomClasses.Companion.FLEXBOX_SHRINKING_ITEM
import com.tixforgigs.common.core.theme.Styles.CustomClasses.Companion.GRID_CONTAINER
import com.tixforgigs.common.core.theme.Styles.CustomClasses.Companion.GRID_ITEM
import io.kvision.core.AlignItems
import io.kvision.core.Display
import io.kvision.core.JustifyItems
import io.kvision.core.Style

object Styles {

  class MandarinClasses {
    companion object {

      const val HEADER = "xm-header"
      const val FOOTER = "xm-footer"
      const val SECTION = "xm-section"
      const val TITLE = "xm-title"
      const val SUBTITLE = "xm-subtitle"
      const val HEADLINE = "xm-headline"
      const val SUBHEADLINE = "xm-subheadline"
      //TODO can be extended
    }

    enum class Shapes(val pixel: Int) {
      SMALL(4),
      MEDIUM(8),
      LARGE(16),
      EXTRA_LARGE(32),
    }
  }

  class CustomClasses {
    companion object {

      const val FLEXBOX_GROWING_ITEM = "flexbox-growing"
      const val FLEXBOX_SHRINKING_ITEM = "flexbox-shrinking"

      const val GRID_CONTAINER = "xm-grid-container"
      const val GRID_ITEM = "xm-grid-item"
      //TODO can be extended
    }
  }

  object GridCss {

    fun gridItemStyle(
      columns: Int,
      startColumn: Int? = null,
      horizontalAlign: JustifyItems? = null,
      verticalAlign: AlignItems? = null
    ) = Style(
      buildString {
        append(".${GRID_ITEM}")
        append("-${startColumn.orElse { "span" }}")
        append("-${columns}")
        horizontalAlign?.let {
          append("-horizontal_${it.name}")
        }
        verticalAlign?.let {
          append("-vertical_${it.name}")
        }
      }
    ) {
      startColumn?.let {
        gridColumnStart = it
      }
      horizontalAlign?.let {
        justifySelf = it
      }
      verticalAlign?.let {
        alignSelf = it
      }
      gridColumnEnd = "span $columns"
    }

    fun gridContainerStyle(
      deviceClass: DeviceClass
    ) = Style(".${GRID_CONTAINER}-${deviceClass.name.lowercase()}") {
      display = Display.GRID
      gridTemplateColumns = when (deviceClass) {
        DeviceClass.MOBILE -> "repeat(6, 1fr)"
        DeviceClass.TABLET, DeviceClass.DESKTOP, DeviceClass.ULTRAWIDE_DEVICE -> "repeat(12, 1fr)"
      }
      gridRowGap = 8
      gridColumnGap = 16
    }
  }

  object FlexCss {

    fun flexGrowingItemStyle() = Style(".${FLEXBOX_GROWING_ITEM}") {
      flexGrow = 1
      flexShrink = 0
    }

    fun flexShrinkingItemStyle() = Style(".${FLEXBOX_SHRINKING_ITEM}") {
      flexShrink = 0
    }
  }
}
